import { CustomDataFieldType } from 'models/CustomDataField';
import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export enum AddCustomFieldType {
  TEXT = CustomDataFieldType.TEXT,
  SINGLE_SELECT = CustomDataFieldType.SINGLE_SELECT,
}

export const addCustomFieldSchema = () => ({
  name: Yup.string().trim().min(1).required(),
  type: Yup.mixed<AddCustomFieldType>()
    .oneOf(Object.values(AddCustomFieldType))
    .required(),
});

export type AddCustomFieldFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof addCustomFieldSchema>>
>;
